module.exports = __webpack_public_path__ + "img/image (41).4b459792.jpg";